import React from 'react';
import Container from './Container';
import { cn } from '@/lib/utils';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  withPadding?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className,
  containerSize = 'lg',
  withPadding = true,
}) => {
  return (
    <main
      className={cn(
        'min-h-[calc(100vh-64px)]',
        withPadding && 'py-8',
        className
      )}
    >
      <Container size={containerSize}>{children}</Container>
    </main>
  );
};

export default PageLayout;